import { render, staticRenderFns } from "./ArticleManage.vue?vue&type=template&id=2879be7e&scoped=true"
import script from "./ArticleManage.vue?vue&type=script&lang=js"
export * from "./ArticleManage.vue?vue&type=script&lang=js"
import style0 from "./ArticleManage.vue?vue&type=style&index=0&id=2879be7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2879be7e",
  null
  
)

export default component.exports